import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import Skeleton from '../../../../common/skeleton';
const PlanDetailsForOthersSkeleton = () => {
  return (
    <>
      <Card className="w-100">
        <Row>
          <Col md={4} lg={4} xs={12}>
            <Skeleton
              count={3}
              height={15}
              width={300}
              className="plan-details-skeleton"
            />
          </Col>
          <Col md={4} lg={4} xs={12}>
            <Skeleton
              count={3}
              height={15}
              width={300}
              className="plan-details-skeleton"
            />
          </Col>
          <Col md={4} lg={4} xs={12}>
            <Skeleton
              count={1}
              height={30}
              width={300}
              className="plan-details-skeleton"
            />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default PlanDetailsForOthersSkeleton;
